import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAuthStatus, getVipStatus } from "./modules/Login/actions/UserAction";
import { CACHE_ACCESS_TOKEN } from "./constants/Profile";
const HocElement = ({ Component, dispatch, store }) => {
    const params = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem(CACHE_ACCESS_TOKEN)
        token && init()
    }, [])

    const init = async () => {
        await dispatch(getAuthStatus())
        await dispatch(getVipStatus())
    }

    return <Component router={{
        params,
        navigate
    }} />
};

// export default HocElement;
function mapStateToProps(store) {
    return {
    }
}

export default connect(mapStateToProps)(HocElement);
